import whatsapp from '../img/social-icon/whatsapp.webp';
import fb from '../img/social-icon/fb.webp';
import insta from '../img/social-icon/insta.webp';

import book1 from '../img/books/book-1.jpg'
import book2 from '../img/books/book-2.jpg'

export const socialData = [
    { 
        id: 1,
        name: "whatsapp",
        link: "https://wa.me/919826156540?text=Hello",
        icon: whatsapp
    },
    { 
        id: 2,
        name: "facebook",
        link: "https://www.facebook.com/profile.php?id=100070438784673",
        icon: fb
    },
    { 
        id: 3,
        name: "instagram",
        link: "https://www.instagram.com/nimishagrawal2005/",
        icon: insta
    }

] 

export const booklist = [
    { 
        id: 1,
        name: "bujhaye na bujhe",
        image: book1,
        buylink: "https://www.amazon.in/dp/8195128696"
    },
    { 
        id: 2,
        name: "Hundred Dates laghukathaen",
        image: book2,
        buylink: "https://amzn.in/d/2YLJGA4"
    }
]